import { h, Component } from 'preact';
import { sortObjectByOrder, joinClasses, accessNested } from 'utils/utils';
import Link from 'components/bolt/link/link';
import HTML from 'components/core/html/html';
import Store from 'store/store';
import s from 'components/bolt/iconicFooter/iconicFooter.sss';
import { smoothScrollTo } from 'utils/smoothScroll';
import Button from 'components/bolt/button/button';
import ArrowDown from 'components/bolt/icons/arrowDown';

export default class IconicFooter extends Component {
	constructor(props) {
		super(props);

		this.renderLink = this.renderLink.bind(this);
	}

	renderIconAddress(icon, address) {

		const activePage = Store.get().activePage;
		let pageData = Store.get().appData.pages[activePage];
		if (pageData.group && Store.get().appData.pages[pageData.group]) {
			pageData = Store.get().appData.pages[pageData.group];
		}
		const customIcon = pageData.customFooterLogo;

		return (
			<div class={joinClasses(s.nav, s.section)}>
				<img class={s.ttIcon} src={customIcon || icon} alt="Iconic Logo" />
				<div class={s.address}>
					{address}
				</div>
			</div>
		);
		// let links = sortObjectByOrder(nav);
		// links = links.concat(sortObjectByOrder(extraNav));

		// return (
		// 	<div class={joinClasses(s.nav, s.section)}>
		// 		{links.map(this.renderLink)}
		// 	</div>
		// );
	}

	renderLink(element) {
		const page = Object.values(this.props.appData.pages).find(page => page.id === element.path)?.id;
		const isInternalLink = !!page || element.path?.startsWith('@');
		const activePage = this.props.activePage || 'boltHome';
		const active = activePage === element.path;
		const copy = this.props.appData?.copy.baseCopy;

		let attributes = {};

		if (!isInternalLink) {
			attributes.href = element.path;
			attributes.target = element.sameWindow ? '_self' : '_blank';
			attributes.rel = 'noopener noreferrer';
		} else {
			attributes.onClick = element.onClick || (() => Store.emit('CLOSE_AND_NAVIGATE', element.path));
		}

		const content = copy[element.name] || element.name;

		return (
			<Link
				key={element.name}
				class={joinClasses(s.link, active && s.active)}
				ariaLabel={element.name}
				{...attributes}
			>
				<HTML class={s.content} content={content} markdown />
			</Link>
		);
	}

	renderCorporate(data) {
		const links = sortObjectByOrder(data).filter(e => typeof e !== 'string');

		return (
			<div class={joinClasses(s.corporate, s.section)}>
				<div class={s.sectionTitle}>
					{data.title}
				</div>
				{links.map(this.renderLink)}
			</div>
		);
	}

	renderGetInTouch(data) {
		const links = sortObjectByOrder(data).filter(e => typeof e !== 'string');

		return (
			<div class={joinClasses(s.getInTouch, s.section)}>
				<div class={s.sectionTitle}>
					{data.title}
				</div>
				{links.map(this.renderLink)}
			</div>
		);
	}

	renderFollow(data) {
		const socials = sortObjectByOrder(data, ((value, key) => [key, value])).filter(e => typeof e[1] !== 'string');
		const accessibilityCopy = this.props.appData?.copy.accessibilityCopy;

		return (
			<div class={s.follow}>
				<div class={s.sectionTitle}>
					{data.title}
				</div>
				<div class={s.socials}>
					{socials.map(([id, social]) => (
						<Link
							class={s.social}
							href={social.destination}
							target="_blank"
							rel="noopener noreferrer"
							ariaLabel={accessibilityCopy.$SOCIAL_ARIA.replace('<platform>', id)}
						>
							<img class={s.icon} src={social.icon} alt='' />
						</Link>
					))}
				</div>
			</div>
		);
	}

	renderNewsletter(data) {
		return (
			<form class={s.newsletter}>
				<div class={s.sectionTitle}>
					{data.title}
				</div>
				<input class={s.field} type="email" name="email" />
				<input class={s.submit} type="submit" value={data.signup} />
			</form>
		);
	}

	renderBafta(data) {
		const { award, category } = data;
		return (
			<div class={s.bafta}>
				<div class={s.sectionTitle}>
					{award}
				</div>
				<div class={s.category}>
					{category}
				</div>
			</div>
		);
	}

	renderLinks(data) {
		let links = sortObjectByOrder(data);

		return (
			<div class={s.links}>
				{links.map(this.renderLink)}
			</div>
		);
	}

	render(props) {
		const { data, appData, store, scrollElem } = props;
		const { icon, address, corporate, getInTouch, follow, newsletter, links } = data;
		const accessibilityCopy = accessNested(store, 'appData.copy.accessibilityCopy', {});

		const isShowtimes = Store.get()?.activePage?.includes('showtimes');

		return (
			<footer class={s.wrapper}>
				<div class={s.container}>
					<div class={joinClasses(s.top, isShowtimes && s.isShowtimes)}>
						{this.renderIconAddress(icon, address)}
						{this.renderCorporate(corporate)}
						{this.renderGetInTouch(getInTouch)}
						{this.renderFollow(follow)}
						{newsletter && this.renderNewsletter(newsletter)}
					</div>
					<div class={s.bottom}>
						<Button
							class={s.scrollTop}
							trigger={() => smoothScrollTo(scrollElem || document.getElementById('mainScroll'), 0, 300)}
							ariaLabel={accessibilityCopy.$SCROLL_UP_ARIA}
						>
							<ArrowDown class={s.arrow} />
						</Button>
						{this.renderLinks(links)}
					</div>
				</div>
			</footer>
		);
	}
}
